/**
 * RubricResultDisplay - Student view of subjective rubric grading
 * Strictly matching ProgrammingActivityV2 / RubricViewV2 student view.
 */
import React from 'react';
import RubricScoreGrid from './RubricScoreGrid';

const RubricResultDisplay = ({
  evaluation = [],
  rubric = [],
  scoredMarks = 0,
  maxMarks = 0,
  remark = '',
}) => {
  if (!Array.isArray(evaluation) || evaluation.length === 0) {
    return null;
  }

  // Construct synthetic rubric structure if full rubric definition wasn't passed directly
  const effectiveRubric =
    rubric && rubric.length > 0
      ? rubric
      : evaluation.map((hist, idx) => ({
          criteria_id: hist.criteria || hist.criteria_id || idx + 1,
          name: hist.criteria_title || `Criterion ${idx + 1}`,
          description: '',
          Ratings: [
            {
              rating_id: hist.rating || hist.rating_id || 1,
              tag: hist.rating_title || 'Awarded Level',
              description: '',
              mark: hist.awarded_marks ?? hist.marks ?? 0,
            },
          ],
        }));

  return (
    <div className="mt-3">
      <h6 className="fw-bold text-dark mb-2">Subjective Rubric Evaluation Breakdown</h6>
      <RubricScoreGrid
        rubric={effectiveRubric}
        initialEvaluation={evaluation}
        initialRemark={remark}
        maxQuestionMarks={maxMarks}
        isStudentView={true}
      />
    </div>
  );
};

export default RubricResultDisplay;
